export default __webpack_public_path__ + "static/media/misc-closetC-768w.ed0f2035.png";